import React, { Fragment, useState, useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import { Alert, Button, ButtonToolbar, Collapse } from 'reactstrap';
import MaterialTable from '../../../shared/components/material-table';
import renderSelectField from '../../../shared/components/form/Select';
import DateField from '../../../shared/components/form/DateField';
import HourField from '../../../shared/components/form/HourField';
import ColumnsAppointment from './ColumnsAppointment';
import GraphQl from '../../../GraphQL';
import {
  itensTabletActiveListByFather,
  relationStudentClassesByFilter,
} from '../../../shared/queries/Appointment';
import { classListActivesByFunc } from '../../../shared/queries/SchoolClass';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import validate from './Validate';
import { studentListByFilter } from '../../../shared/queries/Student';
import SelectVirtualized from '../../../shared/components/form/SelectVirtualized';
import {
  changeLoadingFalse,
  changeLoadingTrue,
} from '../../../redux/actions/loadingActions';
import { EXCLUDED_APPOINTMENTS } from '../../../shared/utils/constants';
import Modal from '../../../shared/components/Modal';

const AppointmentForm = (props) => {
  const {
    t,
    backHandler,
    change,
    handleSubmit,
    dispatch,
    responsibles,
    loadResponsibleStudentByStudentId,
  } = props;
  const [classes, setClasses] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [appointmentStudent, setAppointmentStudent] = useState([]);
  const [listOfItems, setListOfItems] = useState([]);
  const [selectedDate, setSelectedDate] = useState();
  const [selectedHour, setSelectedHour] = useState();
  const [complement, setComplement] = useState();
  const [lastListOfItems, setlastListOfItems] = useState();
  const [firstLevelItemCode, setFirstLevelItemCode] = useState();
  const [program, setProgram] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const [students, setStudents] = useState();
  const [modal, setModal] = useState();
  const [selectedStudentsById, setSelectStudentsById] = useState([]);
  const [selectedStudentsData, setSelectedStudentsData] = useState([]);
  const [selectedResponsible, setSelectResponsible] = useState();
  const [isSelectedEntryOrExitItem, setIsSelectedEntryOrExitItem] = useState();
  const [selectedClassesData, setSelectedClassesData] = useState([]);
  const [showIsRequiredResponsibles, setShowIsRequiredResponsibles] =
    useState(false);
  const currentList = useRef(0);

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const listClasses = () => {
    const query = classListActivesByFunc();
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        res.classListActivesByFunc = res.classListActivesByFunc.map((item) => ({
          ...item,
          label: item.name,
          value: item.id,
        }));
        setClasses(res.classListActivesByFunc);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadStudent = () => {
    if (selectedClasses && selectedClasses.length) {
      const idClasses = selectedClasses.map((item) => item.id);
      setSelectedClasses(selectedClasses);
      if (selectedItems.some((item) => item.addOn === true) && !complement) {
        showNotificationAutoDestroy(
          'warning',
          t('notifications.attention'),
          t('notifications.warning-no-complement')
        );
      } else {
        const listOfnames = selectedItems.map((item) => item.name);
        const itemsCrumb = listOfnames.join('->');
        const filter = {
          id: 0,
          classes: idClasses,
          students: selectedStudentsById.length ? selectedStudentsById : [],
          onlyActive: true,
        };
        showLoading();
        const query = relationStudentClassesByFilter(filter);
        GraphQl(query, {})
          .then((res) => {
            hideLoading();
            res.relationStudentClassesByFilter =
              res.relationStudentClassesByFilter.map((item) => ({
                ...item,
                item: itemsCrumb,
                option: listOfItems,
                dateNote: selectedDate,
                hourNote: selectedHour,
                noteComplement: complement || null,
                firstLevelItemCode,
                program,
                responsible: selectedResponsible,
              }));
            setAppointmentStudent(res.relationStudentClassesByFilter);
          })
          .catch(() => {
            showNotificationAutoDestroy(
              'danger',
              t('errors.title'),
              t('errors.error-to-loading')
            );
            hideLoading();
          });
      }
    }
  };

  const onChangeClassesNamesHandler = (classesSelected) => {
    if (classesSelected) {
      setSelectedClasses([...classesSelected]);
      if (classesSelected.length < currentList.current) {
        setStudents([]);
        change('students', []);
        setSelectStudentsById([]);
      }
      if (appointmentStudent.length > 0) {
        setModal(true);
      } else if (classesSelected && classesSelected.length) {
        setSelectedClassesData(classesSelected);
      }
      currentList.current = classesSelected.length;
      const filter = {
        id: 0,
        classes: classesSelected,
        responsibles: [],
        menus: [],
        onlyActive: true,
      };
      showLoading();
      const query = studentListByFilter(filter);
      GraphQl(query, {})
        .then((res) => {
          hideLoading();
          res.studentListByFilter = res.studentListByFilter.map((item) => ({
            ...item,
            label: item.fullName,
            value: item.id,
          }));
          const updateStudents = [...res.studentListByFilter];
          setStudents(updateStudents);
        })
        .catch(() => {
          hideLoading();
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        });
    } else {
      setStudents([]);
      change('students', []);
      setSelectStudentsById([]);
    }
  };

  const onChangeDate = (date) => {
    setSelectedDate(date);
  };

  const onChangeHour = (event) => {
    setSelectedHour(event.target.value);
  };

  const changeListOfItemsByLevel = (level) => {
    let updateListOfItems = [...listOfItems];
    updateListOfItems = updateListOfItems.filter((item) => item.level < level);
    setListOfItems(updateListOfItems);
  };

  const changeSelectedItemsByLevel = (updatedSelectedItems, level) => {
    const filteredItems = updatedSelectedItems.filter(
      (item) => item.level < level
    );
    setSelectedItems(filteredItems);
  };

  const changeListOfItemsByItemsTablet = (
    itensTabletActiveListByNivel,
    level
  ) => {
    let updateListOfItems = [...listOfItems];
    updateListOfItems = updateListOfItems.filter((item) => item.level < level);
    updateListOfItems = [
      ...updateListOfItems,
      {
        level,
        items: itensTabletActiveListByNivel,
      },
    ];
    return updateListOfItems;
  };

  const onChangeStudentByClass = (values) => {
    if (appointmentStudent.length > 0) {
      setModal(true);
    } else {
      let idStudent = [];
      if (values && values.length) {
        setSelectedStudentsData(values);
        idStudent = values.map(({ id }) => id);
      }
      setSelectStudentsById(idStudent);
    }
  };

  const toggleModal = () => {
    change('students', selectedStudentsData);
    change('classesNames', selectedClassesData);
    setModal(!modal);
  };

  const acceptLostAppointments = () => {
    setAppointmentStudent([]);
    change('item1', null);
    change('', []);
    change('students', []);
    changeListOfItemsByLevel(2);
    change('noteComplement', '');
    setComplement('');
    setModal(!modal);
  };

  const changeLastListOfItems = (level) => {
    const lastLevel = listOfItems.slice(level - 2, level);
    setlastListOfItems(lastLevel[0].items);
  };

  const listItens = (level, fatherId, updatedSelectedItems) => {
    showLoading();
    const query = itensTabletActiveListByFather(level, fatherId);
    GraphQl(query, {})
      .then((res) => {
        hideLoading();
        if (
          res.itensTabletActiveListByNivel &&
          res.itensTabletActiveListByNivel.length
        ) {
          res.itensTabletActiveListByNivel =
            res.itensTabletActiveListByNivel.map((item) => ({
              ...item,
              label: item.shortName,
              value: item.id,
              valueNote: item.itemValue,
            }));
          const updateListOfItems = changeListOfItemsByItemsTablet(
            res.itensTabletActiveListByNivel,
            level
          );
          setListOfItems(updateListOfItems);
          change(`item${level}`, null);
        } else {
          changeListOfItemsByLevel(level);
          changeSelectedItemsByLevel(updatedSelectedItems, level);
          changeLastListOfItems(level);
          change('noteComplement', complement);
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const onChangeSelectedResponsible = (value) => {
    setSelectResponsible(value);
  };

  const isEntryOrExitItem = (option) => {
    return (
      EXCLUDED_APPOINTMENTS.map((appointment) => appointment.id).indexOf(
        option.id
      ) !== -1
    );
  };

  const onItemSelectionChangeHandler = (value) => {
    const updatedSelectedItems = [...selectedItems];
    updatedSelectedItems[value.level - 1] = { ...value };
    setSelectedItems(updatedSelectedItems);
    change('noteComplement', complement);
    if (value && value.level === 1) {
      setFirstLevelItemCode(value.id);
      setSelectedItems([value]);
      setProgram(value.program);
    }
    if (value && value.level) {
      listItens(value.level + 1, value.id, updatedSelectedItems);
    }
    if (appointmentStudent.length) {
      setAppointmentStudent([]);
    }
    setIsSelectedEntryOrExitItem(value && isEntryOrExitItem(value));
  };

  const updateSaveItemsHandler = (data, newData) => {
    const updateAppoitments = [...appointmentStudent];
    const newItemIndex = updateAppoitments.indexOf(data);
    const dataToUpdate = {
      ...newData,
    };
    updateAppoitments[newItemIndex] = dataToUpdate;
    setAppointmentStudent(updateAppoitments);
    change('notes', updateAppoitments);
  };

  const loadData = () => {
    if (
      !selectedDate ||
      !selectedHour ||
      !selectedClasses.length ||
      !selectedItems.length ||
      listOfItems.length !== selectedItems.length
    ) {
      showNotificationAutoDestroy(
        'warning',
        t('notifications.attention'),
        t('mnt_appointment.notifications.warning-no-items-selected')
      );
    } else {
      loadStudent();
    }
  };

  const removeAppoitmentClick = (evt, rowData) => {
    const found = appointmentStudent.findIndex(
      (element) => element === rowData
    );
    const updatedAppointmentStudent = [...appointmentStudent];
    updatedAppointmentStudent.splice(found, 1);
    setAppointmentStudent(updatedAppointmentStudent);
    change('notes', updatedAppointmentStudent);
  };

  const isOptionDisabled = (option) => {
    return isEntryOrExitItem(option) && selectedStudentsById.length !== 1;
  };

  useEffect(() => {
    if (selectedStudentsById.length === 1) {
      const isRequiredResponsible = listOfItems
        .reduce((acc, item) => acc.concat(item.items), [])
        .some(
          (item) =>
            EXCLUDED_APPOINTMENTS.map((appointment) => appointment.id).indexOf(
              item.id
            ) !== -1
        );
      if (isRequiredResponsible) {
        setShowIsRequiredResponsibles(true);
        loadResponsibleStudentByStudentId(selectedStudentsById[0]);
      } else {
        setShowIsRequiredResponsibles(false);
      }
    } else if (showIsRequiredResponsibles) {
      setShowIsRequiredResponsibles(false);
      change('responsible', undefined);
    }
  }, [selectedItems, selectedStudentsById]);

  useEffect(() => {
    listClasses();
    listItens(1, 0);
    change('appoitmentStudent', []);
  }, []);

  useEffect(() => {
    change('selectedItems', selectedItems);
  }, [selectedItems]);

  useEffect(() => {
    change('appoitmentStudent', appointmentStudent);
  }, [appointmentStudent]);

  useEffect(() => {
    if (isSelectedEntryOrExitItem && selectedStudentsById.length === 1) {
      loadResponsibleStudentByStudentId(selectedStudentsById[0]);
    } else {
      change('responsible', undefined);
    }
    if (selectedStudentsById.length !== 1 && isSelectedEntryOrExitItem) {
      change(`item1`, null);
      change('', []);
      changeListOfItemsByLevel(2);
      setIsSelectedEntryOrExitItem(false);
    }
  }, [isSelectedEntryOrExitItem, selectedStudentsById]);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.lost-appointments')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={acceptLostAppointments}
      />
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.date')}</span>
            <div className="form__form-group-field">
              <Field
                name="dateNote"
                type="text"
                component={DateField}
                placeholder={t('general.date')}
                onChange={onChangeDate}
                maxDate={new Date()}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.hour')}</span>
            <div className="form__form-group-field">
              <Field
                name="hourNote"
                type="text"
                component={HourField}
                placeholder={t('general.hour')}
                onChange={onChangeHour}
              />
            </div>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.classes-names')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="classesNames"
              type="text"
              component={renderSelectField}
              isMulti
              clearable
              placeholder={t('general.classes-names')}
              options={classes}
              onChange={onChangeClassesNamesHandler}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.students')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="students"
              type="text"
              component={renderSelectField}
              isMulti
              clearable
              closeMenuOnSelect={false}
              placeholder={t('general.students')}
              options={students}
              onChange={onChangeStudentByClass}
            />
          </div>
        </div>
        {listOfItems.map((items) => (
          <div className="form__form-group" key={items.level}>
            <span className="form__form-group-label">{`${t('general.item')} ${
              items.level
            }`}</span>
            <div className="form__form-group-field">
              <Field
                name={`item${items.level}`}
                component={renderSelectField}
                isClearable={false}
                placeholder={t('general.itens')}
                options={items.items}
                onChange={onItemSelectionChangeHandler}
                isOptionDisabled={isOptionDisabled}
              />
            </div>
          </div>
        ))}
        {isSelectedEntryOrExitItem && (
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.responsible-account')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="responsible"
                component={SelectVirtualized}
                placeholder={t('general.responsible-account')}
                options={responsibles}
                isClearable={false}
                onChange={onChangeSelectedResponsible}
              />
            </div>
          </div>
        )}
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('mnt_appointment.adjunct')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="noteComplement"
              type="text"
              component="textarea"
              maxLength="3000"
              placeholder={t('mnt_appointment.adjunct')}
              onChange={(event) => setComplement(event.target.value)}
            />
          </div>
        </div>
        <ButtonToolbar className="filter-button">
          <Button color="success" onClick={loadData}>
            {t('mnt_appointment.generate-appoitments')}
          </Button>
        </ButtonToolbar>
        <div className="form__form-group">
          <MaterialTable
            data={appointmentStudent}
            columns={ColumnsAppointment(
              t,
              lastListOfItems,
              updateSaveItemsHandler,
              selectedItems[selectedItems.length - 1],
              showIsRequiredResponsibles
            )}
            isFiltering
            toolbar={false}
            paging={false}
            onRemoveClick={removeAppoitmentClick}
          />
        </div>
        <Field
          name="appoitmentStudent"
          component={(field) => (
            <Collapse
              isOpen={field.meta.touched && !!field.meta.error}
              className="width100 mb-2"
            >
              <Alert className="text-center mb-0" color="danger">
                {field.meta.error}
              </Alert>
            </Collapse>
          )}
        />
        <ButtonToolbar>
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

AppointmentForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loadResponsibleStudentByStudentId: PropTypes.func.isRequired,
  responsibles: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    })
  ).isRequired,
};

export default reduxForm({
  form: 'AppointmentForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: false,
})(withTranslation('common')(AppointmentForm));
